import { render, staticRenderFns } from "./BbeeProductosServiciosS.vue?vue&type=template&id=fd111bc4"
import script from "./BbeeProductosServiciosS.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports